module.exports = __webpack_public_path__ + "img/manoscontexto-01.1c114630.png";